const interfaceTranslations = {
  selectedCountryAriaLabel: "País seleccionat",
  noCountrySelected: "No s'ha seleccionat cap país",
  countryListAriaLabel: "Llista de països",
  searchPlaceholder: "Cerca",
  zeroSearchResults: "Sense resultats",
  oneSearchResult: "1 resultat trobat",
  multipleSearchResults: "${count} resultats trobats",
  // additional countries (not supported by country-list library)
  ac: "Illa de l'Ascensió",
  xk: "Kosovo"
};
export default interfaceTranslations;